// Comprovante e saída da mesa (Mesa QR, 24/09/2026).
// Público (cliente, sem login): o comprovante e a imagem do QR de saída.
// Equipe (logado): conferir e liberar a saída.
import axios from "axios";

const API = "/api";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

const erroDe = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail && typeof detail === "object") return detail;
  return { codigo: "ERRO", mensagem: detail || "Não consegui falar com a loja. Tente de novo." };
};

const chamar = async (fn) => {
  try {
    return { ok: true, dados: (await fn()).data };
  } catch (e) {
    return { ok: false, erro: erroDe(e), status: e?.response?.status };
  }
};

export const comprovante = (codigo) => chamar(() => axios.get(`${API}/public/mesa-saida/${codigo}`));

export const qrDaSaida = (codigo) => `${API}/public/mesa-saida/${codigo}/qr.png`;

export const conferir = (codigo) => chamar(() => axios.get(`${API}/mesa-qr/saida/${codigo}`, auth()));

export const liberar = (codigo, { grupo = false, motivo = null } = {}) =>
  chamar(() => axios.post(`${API}/mesa-qr/saida/${codigo}/liberar`, { grupo, motivo }, auth()));

export const lojaPublica = () => chamar(() => axios.get(`${API}/company/settings`));

/** O código de saída dentro do texto lido no QR (o link `.../#/saida/qr/<código>`)
 *  ou o próprio código, quando digitado. */
export function codigoDoTexto(texto) {
  const t = String(texto || "").trim();
  const m = t.match(/saida\/qr\/([A-Za-z0-9_-]{8,})/);
  if (m) return m[1];
  return /^[A-Za-z0-9_-]{8,}$/.test(t) ? t : null;
}
